import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthService } from '../../services/auth/auth.service';
import { GuiMsjService } from '../../services/shared/gui-msj.service';
import { ToastService } from 'src/app/services/mjsSnackBar/toast.service';

@Component({
    selector: 'app-google-redirect',
    templateUrl: './google-redirect.html',
    styleUrls: ['./google-redirect.scss'],
})
export class GoogleRedirectComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authservice: AuthService,
        private toast: ToastService,
    ) {}

    async ngOnInit() {
        console.group('🔁 GOOGLE REDIRECT HANDLER');

        const token = this.route.snapshot.queryParamMap.get('token');
        const error = this.route.snapshot.queryParamMap.get('error');

        console.log('token:', token ? token.substring(0, 20) + '...' : null);
        console.log('error:', error);

        // ❌ Error desde backend
        if (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error de autenticación',
                text: 'No se pudo validar la cuenta de Google.',
            });
            this.router.navigate(['/login']);
            console.groupEnd();
            return;
        }

        if (!token) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo completar el login.',
            });
            this.router.navigate(['/login']);
            console.groupEnd();
            return;
        }

        console.log('🟢 JWT interno recibido');
        await this.authservice.setJWToken(token);

        console.warn('🚀 Validando token interno contra backend');
        const usuario = await this.authservice.validateTokenGoole(token);

        if (!usuario) {
            Swal.fire({
                icon: 'error',
                title: 'Sesión inválida',
                text: 'No se pudo iniciar sesión.',
            });
            this.router.navigate(['/login']);
            console.groupEnd();
            return;
        }

        if (!usuario) {
            this.toast.error('Error en usuario o contraseña.');

            this.router.navigate(['/login']);
            return;
        }

        this.toast.success('Inicio de sesión exitoso.');

        await this.authservice.hydrateSessionFromUser(usuario, token);
        await this.authservice.redirigirSegunPerfil(usuario);

        console.groupEnd();
    }
}
